export default {
  common: {
    all: 'All',
    active: 'Active',
    archive: 'Archive',
    current: 'Current',
    history: 'History',
    status: 'Status',
    dateFrom: 'Date From',
    dateTo: 'Date To',
    days: 'Days',
    day: 'day',
    daysPlural: 'days',
    comment: 'Comment',
    reason: 'Reason',
    decision: 'Decision',
    decisionReason: 'Decision reason',
    note: 'Note',
    period: 'Period',
    requested: 'Requested',
    submitted: 'Submitted',
    notSpecified: 'Not specified',
    available: 'Available',
    notAvailable: 'Not available',
    required: 'Required field',
    tryAgain: 'Try again',
    back: 'Back',
    close: 'Close',
    calculate: 'Calculate',
    submitRequest: 'Submit request',
    cancelRequest: 'Cancel request',
    keepRequest: 'Keep request',
    viewDetails: 'View details ›',
    openDetails: 'Open request details',
    pleaseRetry: 'Please check your connection and try again.',
    noRequests: 'No requests yet',
    requestsAppear: 'Your submitted requests will appear here.',
    formInvalid: 'Check that the form fields are filled in correctly',
    upcoming: 'Upcoming',
    hideCalculation: 'Hide calculation details',
    calculation: 'Calculation details',
    hideDeductions: 'Hide deduction history',
    deductionsCount: 'Deduction history ({count})',
    hideSchedule: 'Hide payment schedule',
    scheduleCount: 'Payment schedule ({count})',
    supportingDocument: 'Supporting document',
    employee: 'Employee',
    unknown: 'Unknown',
    yes: 'Yes',
    no: 'No',
    sectionComingSoon: 'This section will be available here.',
  },
  language: { selector: 'Language selector', sw: 'SW', en: 'EN', swahili: 'Swahili', english: 'English', comingSoon: 'Swahili is coming soon' },
  uploader: { attach: 'Attach the file', view: 'View file', uploading: 'Uploading', delete: 'Remove file', tooMany: 'You cannot upload more than 1 file', wrongFormat: 'Wrong file format', tooLarge: 'File size exceeds allowed' },
  auth: {
    welcome: 'Welcome To Altezza Board',
    login: 'Login',
    password: 'Password',
    forgot: 'Forgot password?',
    logIn: 'Log In',
    required: 'Required field',
    shortPassword: 'Password length less than 4 characters',
    otp: 'Enter 6 digit code from auth app',
    support: 'Unable to log in. Please contact HR for assistance.',
    forgotTitle: 'Forgot password',
    forgotDescription: 'Enter the email linked to your Personal Cabinet.',
    email: 'Email',
    sendInstructions: 'Send instructions',
    neutralResult: 'If a personal cabinet exists, password reset instructions have been sent.',
    backToLogin: 'Back to login',
    newPinTitle: 'Set a new PIN',
    newPinDescription: 'Enter the same six-digit PIN twice.',
    newPin: 'New PIN',
    confirmPin: 'Confirm PIN',
    pinMismatch: 'PINs do not match',
    invalidLink: 'This link is invalid, expired, or has already been used. Request a new link.',
    changePin: 'Change PIN',
    changed: 'Your PIN has been changed. You can now log in.',
    requestNewLink: 'Request a new link',
  },
  nav: {
    home: 'Home',
    requests: 'Requests',
    payslips: 'Payslips',
    profile: 'Profile',
    loans: 'Loans',
    advances: 'Advances',
    heslb: 'HESLB',
    leave: 'Leave',
    medical: 'Medical Reports',
    misconduct: 'Misconduct',
    logout: 'Log out',
    openMenu: 'Open full menu',
    closeMenu: 'Close menu',
    employeeNavigation: 'Employee navigation',
    workspace: 'Workspace',
    driverWorkspace: 'Driver workspace',
    workspaceHint: 'Open your work tools',
  },
  overview: {
    unavailable: 'Overview is unavailable',
    loadError: 'We could not load your employee overview.',
    employee: 'Employee',
    since: 'WITH ALTEZZA SINCE {year}',
    salary: 'Salary',
    salaryEstimate: 'Salary estimate',
    hideSalary: 'Hide salary',
    showSalary: 'Show salary',
    salaryHidden: 'Salary hidden',
    debtNote: 'Loans and advances have not yet been deducted from this amount.',
    netOf: 'Net of PAYE, NSSF & NHIF',
    payday: 'Payday: {date}',
    salaryMissing: 'Salary estimate is not available yet',
    salaryMissingHelp: 'Your overview will update as soon as the estimate is prepared.',
    service: 'At your service',
    promise: 'Every request is handled personally by the management.',
    promiseTime: 'Typically within one business day.',
    morning: 'Good Morning',
    afternoon: 'Good Afternoon',
    evening: 'Good Evening',
    requestAdvance: 'Request Advance',
    salaryAdvance: 'Salary in Advance',
    requestLoan: 'Request Loan',
    staffProgramme: 'Staff Programme',
    reportSick: 'Report Sick',
    leaveAbsence: 'Leave of Absence',
    requestVacation: 'Request Vacation',
    annualLeave: 'Annual Leave',
    maternity: 'Maternity Leave',
    parental: 'Parental Leave',
    unpaid: 'Unpaid Leave',
    personalTime: 'Personal Time',
    reportMisconduct: 'Report Misconduct',
    confidence: 'In Confidence',
    suggestIdea: 'Suggest an Idea',
    founders: 'To the Founders',
    myHistory: 'My History',
    pastRequests: 'Past Requests',
  },
  profile: {
    eyebrow: 'Employee details',
    title: 'Profile',
    subtitle: 'Your current employment and payment information.',
    unavailable: 'Profile is unavailable',
    employment: 'Employment',
    contacts: 'Contacts',
    salaryPayment: 'Salary payment',
    type: 'Type',
    employedSince: 'Employed since',
    legalEntity: 'Legal entity',
    contractPeriod: 'Contract period',
    email: 'Email',
    phone: 'Phone',
    whatsapp: 'WhatsApp',
    telegram: 'Telegram',
    method: 'Method',
    bank: 'Bank',
    account: 'Account',
  },
  requests: {
    employeeService: 'Employee service',
    title: 'Requests',
    historyTitle: 'My History',
    activeSubtitle: 'All your requests in one place.',
    historySubtitle: 'Completed and closed requests.',
    unavailable: 'Requests are unavailable',
    noCompleted: 'No completed requests yet',
    detailTitle: 'Request details',
    detailSubtitle: 'The latest information from the source request.',
    unavailableOne: 'Request is unavailable',
    salaryAdvance: 'Salary advance',
    staffLoan: 'Staff loan',
    leaveRequest: 'Leave request',
    idea: 'Idea',
    misconduct: 'Misconduct report',
    request: 'Request',
  },
  finance: {
    payrollMonth: 'Payroll month',
    netPayAfter: 'Net pay after',
    rejectionReason: 'Rejection reason',
    expectedSalaryAfter: 'Expected salary after',
    grossSalary: 'Gross salary',
    netSalaryBeforeDebt: 'Net salary before debt',
    salaryPercentAfter: 'Salary percentage after',
    amount: 'Amount (TZS)',
    positiveAmount: 'Enter a positive amount',
    maximumAvailable: 'Maximum available',
    requestedAmount: 'Requested amount',
    principal: 'Principal',
    interest: 'Interest ({percent}%)',
    totalRepayment: 'Total repayment',
    monthlyPayment: 'Monthly payment',
    firstDeduction: 'First deduction',
    availableMonthlyDeduction: 'Available monthly deduction',
    installments: 'Installments',
  },
  advances: {
    minimumAmount: 'The minimum salary advance is 30,000 TZS.',
    title: 'Advances',
    request: 'Request advance',
    unavailable: 'Advances are unavailable',
    newRequest: 'New salary advance request',
    monthlyLimit: 'Only one salary advance can be requested per payroll month.',
    cancelTitle: 'Cancel salary advance request?',
    moveHistory: 'This request will be moved to History.',
    notePlaceholder: 'What is this advance for?',
    rejectedWarning: 'Submitting this request will create it with a rejected status.',
  },
  loans: {
    pdfError: 'The payment schedule PDF could not be opened.',
    title: 'Loans',
    request: 'Request loan',
    tenure: 'Staff loans are unavailable to employees who have worked at Altezza for less than 6 months.',
    activeBlocked: 'A new request will be available after your active staff loan has been fully repaid.',
    oneActive: 'Only one active staff loan is allowed until it has been fully repaid.',
    unavailable: 'Loans are unavailable',
    newRequest: 'New staff loan request',
    cancelTitle: 'Cancel staff loan request?',
    notePlaceholder: 'What is this loan for?',
    paid: 'Paid',
    nextDeduction: 'Next deduction',
    remaining: 'remaining',
    preparingSchedule: 'Preparing schedule...',
    downloadSchedule: 'Download payment schedule',
    schedulePrincipal: 'Principal {principal} · Interest {interest}',
  },
  heslb: {
    unavailable: 'HESLB information is unavailable',
    empty: 'No HESLB records yet',
    emptyHelp: 'Your HESLB loan information will appear here.',
    balance: 'balance',
    initial: 'Initial amount',
    deducted: 'Deducted',
    currentBalance: 'Current balance',
  },
  leave: {
    timeAway: 'Time away',
    healthFamily: 'Health & family',
    title: 'Leave',
    medicalTitle: 'Medical Reports',
    vacationSubtitle: 'Paid and unpaid vacation requests.',
    medicalSubtitle: 'Sick leave and parental absence are handled separately from vacation.',
    unavailable: 'This page is unavailable',
    unavailableHelp: 'Types and request history could not be loaded.',
    availableType: 'Available request type',
    unpaidNotice: 'Unpaid leave is not paid and should only be requested in exceptional circumstances.',
    maternityNotice: 'Maternity Leave: 90 paid days. Additional leave may be available in case of medical complications, please contact HR.',
    paternityNotice: 'Paternity Leave: 15 paid days.',
    childBonusNotice: 'A TZS 250,000 child bonus will be paid after the child is born.',
    requestLeave: 'Request leave',
    submitMedical: 'Submit medical report',
    requestMaternity: 'Request Maternity Leave',
    requestPaternity: 'Request Paternity Leave',
    noTypes: 'No request types are available',
    noTypesHelp: 'Only types returned by the employee API can be submitted.',
    history: 'Your {type} history',
    leaveHistory: 'leave',
    medicalHistory: 'medical',
    noRequests: 'No requests yet',
    childBonus: 'Child bonus: {amount} TSh · {status}',
    paid: 'Paid',
    unpaid: 'Unpaid',
    viewDocument: 'View supporting document',
    cancelling: 'Cancelling…',
    expectedBirth: 'Expected Birth Date',
    birthDate: 'Birth Date',
    newbornBirthDate: 'Newborn Child\'s Birth Date',
    selectExpectedBirth: 'Select expected birth date',
    selectBirth: 'Select birth date',
    birthFuture: 'Choose a birth date within six months before or after today',
    childNotBorn: 'The child has not been born yet. Paternity leave may start up to three days before the expected birth date.',
    fromDate: 'From date',
    sickStartLabel: 'Sick leave start date',
    fromToday: 'From today',
    fromYesterday: 'From yesterday',
    maternityFrom: 'Maternity Leave From',
    toDate: 'To date',
    selectStart: 'Select start date',
    selectEnd: 'Select end date',
    invalidPeriod: 'Choose a valid period within the maximum leave duration',
    duration: 'Maximum: {maximum} days · Selected: {selected} days',
    tellReason: 'Tell us briefly why you need this leave',
    birthCertificate: 'Attachment: Birth Certificate',
    birthCertificateOptional: 'The birth certificate can be added after the request is submitted.',
    optionalMedicalAttachment: 'Medical document (optional)',
    addBirthCertificate: 'Add birth certificate',
    uploadDocument: 'Upload document',
    replaceDocument: 'Replace document',
    documentRequiredOnSubmit: 'This document is required before you submit the request.',
    documentMayBeAddedLater: 'You can attach the document now or upload it after the request is created.',
    documentOptional: 'This document is optional.',
    documentRequiredLater: 'This document is required and can be uploaded or replaced after the request is created.',
    documentOptionalLater: 'This document is optional and can be uploaded or replaced.',
    saveAttachment: 'Save attachment',
    attachmentSaved: 'Document saved',
    newRequest: 'New {type} request',
    newLeave: 'New leave request',
    newMedical: 'New medical report',
    submitted: 'Request submitted',
    createdWithStatus: 'Request created. Status: {status}',
    cancelTitle: 'Cancel this request?',
    cancelHelp: 'The request will be moved to History if it is still awaiting review.',
    type: 'Leave type',
    selectType: 'Select leave type',
    vacation: 'Vacation',
    sickLeave: 'Sick Leave',
    other: 'Other',
    pastAllowed: 'may include dates in the past',
    startPast: 'Vacation cannot start in the past',
    endBeforeStart: 'To date cannot be before From date',
    requestSubmitted: 'Leave request submitted. Awaiting HR review.',
  },
  leaveTypes: {
    paid_leave: 'Paid Leave', unpaid_leave: 'Unpaid Leave', sick_leave: 'Sick Leave', maternity_leave: 'Maternity Leave', paternity_leave: 'Paternity Leave',
  },
  feedback: {
    improve: 'Help us improve',
    confidential: 'Confidential channel',
    ideaTitle: 'Suggest an Idea',
    misconductTitle: 'Report Misconduct',
    ideaSubtitle: 'Your opinion is very valuable to us.',
    misconductSubtitle: 'This report is anonymous to the HR team. Only the General Manager can identify the sender.',
    ideaNotice: 'Have an idea that could improve Altezza? We’d love to hear it.',
    misconductNotice: 'All reports are confidential and will be reviewed by Management.',
    submitIdea: 'Submit an Idea',
    reportMisconduct: 'Report misconduct',
    yourIdeas: 'Your ideas',
    yourReports: 'Your reports',
    historyUnavailable: 'History is unavailable',
    noIdeas: 'No ideas submitted yet',
    noReports: 'No reports submitted yet',
    ideasAppear: 'Your submitted ideas will appear here.',
    reportsAppear: 'Your submitted reports will appear here.',
    category: 'Category',
    chooseCategory: 'Choose a category',
    suggestion: 'Your suggestion',
    happened: 'What happened?',
    shareIdea: 'Share your idea with us',
    describe: 'Describe the situation clearly',
    submitReport: 'Submit report',
    ideaSubmitted: 'Idea submitted',
    reportSubmitted: 'Report submitted',
    managementAnswer: 'Management answer',
  },
  categories: { colleagues: 'Colleagues', management: 'Management', working_conditions: 'Working conditions', other: 'Other' },
  payslips: {
    title: 'Payslips',
    year: 'Payslip year',
    summary: '{year} summary',
    completed: '{count} completed payslips',
    grossEarned: 'Gross earned',
    benefits: 'Benefits',
    deductions: 'Deductions',
    accrued: 'Accrued',
    summaryUnavailable: 'Summary is temporarily unavailable.',
    unavailable: 'Payslips are unavailable',
    none: 'No payslips for {year} yet',
    appear: 'Your completed payslips will appear here.',
    gross: 'Gross',
    hideDetails: 'Hide payslip details',
    showDetails: 'Show payslip details',
    preparingPdf: 'Preparing PDF...',
    downloadPdf: 'Download PDF',
    pdfError: 'PDF could not be downloaded',
    basicSalary: 'Basic salary',
    allowance: 'Allowance',
    benefitsBonuses: 'Benefits / bonuses',
    salaryWarnings: 'Salary warnings',
    advance: 'Advance',
    staffLoan: 'Staff loan',
    earnings: 'Earnings',
    adjustments: 'Adjustments',
    paidByYou: 'Paid by you',
    paidByCompany: 'Paid by company',
  },
  statuses: {
    submitted: 'Submitted',
    requested: 'Requested',
    pending: 'Pending',
    in_review: 'In review',
    approved: 'Approved',
    active: 'Active',
    reviewed: 'Reviewed',
    repaid: 'Repaid',
    fully_paid: 'Fully paid',
    completed: 'Completed',
    rejected: 'Rejected',
    cancelled: 'Cancelled',
    abandoned: 'Abandoned',
    disbursed: 'Disbursed',
    upcoming: 'Upcoming',
    in_process: 'In process',
    past: 'Past',
    planned: 'Planned',
    deducted: 'Deducted',
    written_off: 'Written off',
    imported_confirmed: 'Imported confirmed',
    migrated_review: 'Under review',
    unpaid: 'Unpaid',
    paid: 'Paid',
    unknown: 'Unknown',
  },
  employmentStatuses: {
    working: 'Working', fired: 'Fired', terminated: 'Terminated', retired: 'Retired', retrenched: 'Retrenched', resigned: 'Resigned',
  },
  employmentTypes: { full: 'Full-time', freelance: 'Freelance' },
  paymentMethods: { bank: 'Bank', cash: 'Cash', mobile: 'Mobile', gepg: 'GePG' },
  sources: { advance: 'Salary advance', staff_loan: 'Staff loan', leave: 'Leave request', idea: 'Suggest an idea', misconduct: 'Report misconduct' },
  fields: {
    answer: 'Management answer',
    answered_at: 'Answered at',
    source_id: 'Source ID',
    amount: 'Amount',
    currency: 'Currency',
    payroll_month: 'Payroll month',
    employee_notes: 'Note',
    net_pay_percent_after: 'Net pay after',
    created_at: 'Created',
    updated_at: 'Updated',
    from_date: 'Date from',
    to_date: 'Date to',
    days: 'Days',
    reason: 'Reason',
    decision_reason: 'Decision reason',
    parental_date: 'Birth date',
    text: 'Text',
    kind: 'Type',
    can_cancel: 'Can be cancelled',
    installments: 'Installments',
    interest_amount: 'Interest',
    total_repayment_amount: 'Total repayment',
    installments_count: 'Installments',
    interest_percent: 'Interest rate',
    first_payroll_month: 'First payroll month',
    paid_amount: 'Paid amount',
    remaining_balance: 'Remaining balance',
    note: 'Note',
    apply_in_payroll: 'Payroll month',
    rejection_reason: 'Rejection reason',
    repaid_at: 'Repaid at',
    approved_at: 'Approved at',
    disbursed_at: 'Disbursed at',
    cancelled_at: 'Cancelled at',
  },
}
